<template>
    <div class="bg-white shadow-md mb-64 rounded mx-auto relative p-48 max-w-640">
        <popup-content :description="$t('free_trial.choice.description')" :progress="20" :title="$t('free_trial.choice.title')"></popup-content>

        <div v-for="(choice, index) in choices"
             :class="activeChoice === 'choice-' + index ? 'bg-secondary-5 outline outline-secondary-40 border-transparent' : 'border-primary-5 hover:border-secondary-40 hover:bg-secondary-5'"
             class="flex cursor-pointer mt-32 mb-16 rounded p-24 border transition-all"
             @click="setChoice(index) "
        >
            <div class="flex-1 flex">
                <div>
                    <strong class="block text-body font-semibold mb-8 leading-none">{{ choice.title }}</strong>
                    <p>{{ choice.description }}</p>
                    <em class="block mt-8 text-body-sm">{{ choice.extra }}</em>
                </div>
            </div>

            <svg-icon :class="activeChoice === 'choice-' + index ? 'opacity-1' : 'opacity-0'"
                      class="h-20 w-20 text-secondary-80 transition-all" type="check-circle"></svg-icon>
        </div>

        <div class="mt-48 flex justify-center space-x-20">
            <simple-button class="uppercase w-200"
                           look="secondary"
                           @click="$emit('previous')">
                {{ $t('general.back') }}
            </simple-button>

            <simple-button :disabled="!activeChoice"
                           class="uppercase w-200"
                           display="secondary"
                           look="primary"
                           @click="handleClick">
                <template v-if="!activeChoice || activeChoice === 'choice-' + 0">
                    {{ $t('jobs.next_step') }}
                </template>
                <template v-else>
                    {{ $t('free_trial.direct_start') }}
                </template>
            </simple-button>
        </div>
    </div>
</template>

<script>
import SimpleButton from '../SimpleButton.vue';
import SvgIcon from '../SvgIcon.vue';
import PopupContent from './PopupContent.vue';

export default {
    name: 'SelectStep',
    components: {PopupContent, SvgIcon, SimpleButton},
    props: {
        selected_choice: String,
    },
    data() {
        return {
            activeChoice: null,
        };
    },
    computed: {
        choices() {
            return [
                {
                    title: this.$t('free_trial.choice.choice_1.title'),
                    description: this.$t('free_trial.choice.choice_1.description'),
                    extra: this.$t('free_trial.choice.choice_1.extra'),
                },
                {
                    title: this.$t('free_trial.choice.choice_2.title'),
                    description: this.$t('free_trial.choice.choice_2.description'),
                    extra: this.$t('free_trial.choice.choice_2.extra'),
                },
            ];
        },
    },
    methods: {
        handleClick() {
            if (this.activeChoice === 'choice-' + 0) {
                //Skip a step
                return this.$emit('next', 4);
            }

            return this.$emit('next');
        },
        setChoice(index) {
            let type = 'choice-' + index;

            this.$emit('setChoice', type);
            this.activeChoice = type;
        },
    },
    mounted() {
        if (this.selected_choice) {
            this.activeChoice = this.selected_choice;
        }
    },
};
</script>